import styled from 'styled-components';

export const Heading = styled.h3`
  /* margin-bottom: 32px; */
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.15px;
`;
